import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Media, Row } from "reactstrap";
import footerImage from "../../../../assets/preview/facebook-buttons-footer.png";
import fakeText from "../../../../assets/preview/preview-fake-text.png";
import { useAdvertisementCore } from "../../../../cores/advertisements";
import { useFacebookAdsCore } from "../../../../cores/facebookAds";

export const FacebookFeedPreview = () => {
  const { settings } = useFacebookAdsCore();
  const { name, avatarUrl } = settings || {};
  const { image, campaign } = useAdvertisementCore();

  return (
    <div
      className="neu-out p-2 overflow-hidden"
      style={{ width: 250, height: 320 }}
    >
      <Row className="facebookPreview-header px-4">
        <Col xs="8" className="d-flex align-items-center p-0">
          <div>
            <img
              className="rounded-circle mr-1"
              src={avatarUrl}
              style={{
                width: 30,
                height: 30,
              }}
              alt="avatar"
            />
          </div>
          <div>
            <div style={{ fontSize: 10 }} className="font-weight-bold">
              {name}
            </div>
            <div style={{ fontSize: 10 }}>Publicidad</div>
          </div>
        </Col>
        <Col
          xs="4"
          className="d-flex align-items-center justify-content-end p-0"
        >
          <FontAwesomeIcon icon={["fas", "ellipsis-v"]} />
        </Col>
      </Row>
      <Row className="px-4 pb-2">
        {campaign.description ? (
          <div style={{ fontSize: 10 }} className="text-nowrap text-truncate">
            {campaign.description}
          </div>
        ) : (
          <img
            className="facebookPreview-footer"
            src={fakeText}
            alt="fake-text"
          />
        )}
      </Row>
      <Row className="d-flex justify-content-center align-items-center px-2">
        {image.url ? (
          <Media
            src={image.url}
            className="w-100 h-100"
            style={{
              objectFit: "cover",
              objectPosition: "50% top",
            }}
          />
        ) : (
          <FontAwesomeIcon
            size="6x"
            className="my-4"
            icon={["fas", "camera"]}
          />
        )}
      </Row>
      {campaign.urlBusiness && (
        <Row
          className="bg-light p-1 d-flex flex-column"
          style={{ fontSize: 10 }}
        >
          <div className="px-2">
            {campaign.urlBusiness.replace("http://", "").replace("www.", "")}
          </div>
          <div className="px-2 font-weight-bold">
            {campaign.urlBusiness.replace("http://", "")}
          </div>
        </Row>
      )}
      <Row className="px-2">
        <img
          className="facebookPreview-footer"
          src={footerImage}
          alt="footer"
        />
      </Row>
    </div>
  );
};
